import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=6dd55e1c&scoped=true&"
import script from "./notfound.vue?vue&type=script&lang=js&"
export * from "./notfound.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./notfound.vue?vue&type=style&index=0&id=6dd55e1c&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6dd55e1c",
  "5ac4a3ee"
  
)

export default component.exports